export default "<div style=\"text-align: center;\">\n<h4>Sorry this web site in under construction</h4>\n</div>\n"